import styled from 'styled-components'
import Browser from '../../../../../services/Browser'
import { breakpoints } from '../../../../../constants'

export const StyledForm = styled.form`
	display: ${Browser.isInternetExplorer() ? 'flex' : 'grid'};
	grid-gap: 4rem 15px;
	margin-bottom: 4rem;
	justify-content: ${Browser.isInternetExplorer() ? 'space-between' : ''};
	flex-wrap: wrap;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		grid-template-columns: repeat(5, 1fr);
	}

	& > * {
		width: ${Browser.isInternetExplorer() ? '190px' : null};
		margin: ${Browser.isInternetExplorer() ? '0 15px 4rem 0' : null};
	}

	& > :last-child {
		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			grid-row: 2 / span 1;
			grid-column: 5;
			margin-left: ${Browser.isInternetExplorer() ? '0px' : null};
			${Browser.isInternetExplorer()
				? 'position: relative; left: 80%;'
				: ''};
		}
	}
	/*
	 * Barra de ações: "Exportar compras de passagem" e "Consultar". A barra ocupa da coluna 3 até o
	 * fim e alinha à direita, com o "Consultar" (a ação principal) por último. O espaçamento sai de irmão-adjacente em vez da propriedade gap, que o
	 * IE11 não suporta e este projeto ainda trata.
	 */
	.buttons {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: flex-end;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			grid-column: 3 / -1;
		}

		button {
			max-width: unset !important;
			padding-left: 20px;
			padding-right: 20px;
			white-space: nowrap;
		}

		& > * + * {
			margin-left: 10px;
		}

		/* No celular cada ação ocupa a linha inteira: botões lado a lado ficariam ilegíveis. */
		@media screen and (max-width: ${breakpoints.MOBILE}px) {
			justify-content: stretch;

			button {
				flex: 1 1 100%;
			}

			& > * + * {
				margin-left: 0;
				margin-top: 8px;
			}
		}
	}
	.exportar {
		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			grid-column: 4;
			margin-left: ${Browser.isInternetExplorer() ? 'auto' : null};
		}
	}
`
export const BpeDiv = styled.div`
	display: flex;
	align-items: flex-start;
	margin: 4px 0px;

	span:first-child {
		flex: 1;
		min-width: 0;
		word-break: break-all;
	}

	.fa-copy {
		flex-shrink: 0;
		margin-left: 10px;
		margin-top: 3px;
	}

	a {
		margin-left: 10px;
	}
`
